(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function addItems(ids, button) {
    var list = (ids || [])
      .map(function (id) {
        return String(id || '').trim();
      })
      .filter(Boolean);
    if (!list.length) return Promise.resolve();
    if (!window.ScenarioCart || typeof window.ScenarioCart.addItems !== 'function') {
      return Promise.reject(new Error('cart unavailable'));
    }
    return window.ScenarioCart.addItems({
      items: list.map(function (id) {
        return { id: id, quantity: 1 };
      }),
      button: button,
      source: '3o-creator'
    });
  }

  function relocateAnchorNav(root) {
    if (!root) return;
    var slot = root.querySelector('[data-oa-anchor-slot]');
    var nav = document.querySelector('.event-anchor-nav');
    if (!slot || !nav) return;

    var wrap = nav.closest('[id^="shopify-section-"]');
    var oaWrap = root.closest('[id^="shopify-section-"]');

    if (nav.parentNode !== slot) {
      slot.appendChild(nav);
    }
    nav.classList.add('is-placed');

    if (wrap && wrap !== oaWrap) {
      wrap.setAttribute('hidden', '');
      wrap.style.display = 'none';
    }
  }

  function moneyFromCents(cents, moneyFormat) {
    var raw = ((Number(cents) || 0) / 100).toFixed(2);
    if (moneyFormat && moneyFormat.indexOf('{{amount}}') !== -1) {
      return moneyFormat.replace('{{amount}}', raw);
    }
    return '$' + raw;
  }

  function refreshAcc(root) {
    var cards = root.querySelectorAll('[data-oa-acc-card].is-selected');
    var countEl = root.querySelector('[data-oa-acc-count]');
    var totalEl = root.querySelector('[data-oa-acc-total]');
    var bar = root.querySelector('[data-oa-acc-bar]');
    var total = 0;
    var count = 0;
    cards.forEach(function (card) {
      if (!card.classList.contains('is-on')) return;
      count += 1;
      total += Number(card.getAttribute('data-price') || 0);
    });
    if (countEl) countEl.textContent = String(count);
    if (totalEl) totalEl.textContent = moneyFromCents(total, root.getAttribute('data-money-format'));
    if (bar) bar.hidden = count === 0;
  }

  function clearAcc(root) {
    root.querySelectorAll('[data-oa-acc-card].is-selected').forEach(function (card) {
      card.classList.remove('is-selected');
    });
    refreshAcc(root);
  }

  function initTabs(root, tabSel, itemSel, keyAttr) {
    var tabs = root.querySelectorAll(tabSel);
    var items = root.querySelectorAll(itemSel);
    if (!tabs.length) return;

    function show(key) {
      tabs.forEach(function (tab) {
        tab.classList.toggle('is-active', tab.getAttribute(keyAttr) === key);
      });
      items.forEach(function (el) {
        el.classList.toggle('is-on', el.getAttribute(keyAttr) === key);
      });
      if (keyAttr === 'data-oa-acc') {
        var grid = root.querySelector('[data-oa-acc-grid]');
        if (grid) grid.scrollLeft = 0;
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        show(tab.getAttribute(keyAttr));
        if (keyAttr === 'data-oa-acc') clearAcc(root);
      });
    });

    var current = root.querySelector(tabSel + '.is-active');
    show((current && current.getAttribute(keyAttr)) || tabs[0].getAttribute(keyAttr));
  }

  function initScenes(root) {
    var stage = root.querySelector('[data-oa-scene-stage]');
    if (!stage) return;
    var tabs = root.querySelectorAll('[data-oa-scene-tab]');
    var cards = root.querySelectorAll('[data-oa-scene-card]');
    var scroller = stage.querySelector('.oa-channel__scenes');
    var prev = stage.querySelector('[data-oa-scene-prev]');
    var next = stage.querySelector('[data-oa-scene-next]');
    if (!tabs.length || !cards.length) return;
    var key = '';
    var index = 0;

    function mobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function group() {
      return Array.prototype.filter.call(cards, function (card) {
        return card.getAttribute('data-oa-scene') === key;
      });
    }

    function show(nextKey, nextIndex) {
      key = nextKey;
      var list = group();
      if (!list.length) return;
      index = ((nextIndex % list.length) + list.length) % list.length;
      tabs.forEach(function (tab) {
        tab.classList.toggle('is-active', tab.getAttribute('data-oa-scene') === key);
      });
      if (mobile()) {
        cards.forEach(function (card) {
          card.classList.toggle('is-on', card.getAttribute('data-oa-scene') === key);
        });
        if (prev) prev.hidden = true;
        if (next) next.hidden = true;
        if (scroller) {
          scroller.classList.toggle('is-multi', list.length > 1);
          scroller.scrollLeft = 0;
        }
        return;
      }
      if (scroller) scroller.classList.remove('is-multi');
      cards.forEach(function (card) {
        card.classList.toggle('is-on', card === list[index]);
      });
      var hideArrows = list.length < 2;
      if (prev) prev.hidden = hideArrows;
      if (next) next.hidden = hideArrows;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        show(tab.getAttribute('data-oa-scene'), 0);
      });
    });
    if (prev) {
      prev.addEventListener('click', function () {
        if (mobile()) return;
        show(key, index - 1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        if (mobile()) return;
        show(key, index + 1);
      });
    }
    window.addEventListener('resize', function () {
      show(key || tabs[0].getAttribute('data-oa-scene'), index);
    });

    var current = root.querySelector('[data-oa-scene-tab].is-active') || tabs[0];
    show(current.getAttribute('data-oa-scene'), 0);
  }

  function initAccessories(root) {
    var grid = root.querySelector('[data-oa-acc-select]');
    if (!grid) return;
    grid.addEventListener('click', function (event) {
      var card = event.target.closest('[data-oa-acc-card]');
      if (!card || !grid.contains(card)) return;
      if (event.target.closest('a, button')) return;
      card.classList.toggle('is-selected');
      refreshAcc(root);
    });
    var addBtn = root.querySelector('[data-oa-acc-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function (event) {
        event.preventDefault();
        var ids = [];
        root.querySelectorAll('[data-oa-acc-card].is-selected.is-on').forEach(function (card) {
          var id = card.getAttribute('data-variant-id');
          if (id) ids.push(id);
        });
        addItems(ids, addBtn).catch(function () {});
      });
    }
    refreshAcc(root);
  }

  function initVsMore(root) {
    var btn = root.querySelector('[data-oa-vs-toggle]');
    var more = root.querySelector('[data-oa-vs-more]');
    if (!btn || !more) return;
    btn.addEventListener('click', function () {
      var opening = more.hasAttribute('hidden');
      if (opening) more.removeAttribute('hidden');
      else more.setAttribute('hidden', '');
      btn.textContent = opening ? (btn.getAttribute('data-less') || 'View less') : (btn.getAttribute('data-more') || 'View more');
    });
  }

  function initPills(root) {
    function mobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    root.querySelectorAll('[data-oa-pills]').forEach(function (scroller) {
      var wrap = scroller.parentElement;
      if (!wrap) return;
      var prev = wrap.querySelector('[data-oa-pills-prev]');
      var next = wrap.querySelector('[data-oa-pills-next]');

      function maxScroll() {
        return Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      }

      function setArrow(arrow, visible) {
        if (!arrow) return;
        arrow.classList.toggle('is-visible', !!visible);
        arrow.setAttribute('aria-hidden', visible ? 'false' : 'true');
      }

      function updateArrows() {
        if (!mobile() || maxScroll() <= 2) {
          setArrow(prev, false);
          setArrow(next, false);
          return;
        }
        var sl = scroller.scrollLeft;
        var max = maxScroll();
        setArrow(prev, sl > 4);
        setArrow(next, sl < max - 4);
      }

      function reveal(btn) {
        if (!mobile()) return;
        var view = scroller.getBoundingClientRect();
        var box = btn.getBoundingClientRect();
        if (box.left < view.left + 1) {
          scroller.scrollTo({ left: scroller.scrollLeft - (view.left - box.left), behavior: 'smooth' });
        } else if (box.right > view.right - 1) {
          scroller.scrollTo({ left: scroller.scrollLeft + (box.right - view.right), behavior: 'smooth' });
        }
      }

      function step(dir) {
        var items = Array.prototype.filter.call(scroller.children, function (node) {
          return node.nodeType === 1;
        });
        if (!items.length) return;
        var view = scroller.getBoundingClientRect();
        var sl = scroller.scrollLeft;
        var i;
        if (dir > 0) {
          for (i = 0; i < items.length; i++) {
            var box = items[i].getBoundingClientRect();
            if (box.right > view.right + 2) {
              scroller.scrollTo({ left: sl + (box.left - view.left), behavior: 'smooth' });
              return;
            }
          }
        } else {
          for (i = items.length - 1; i >= 0; i--) {
            var edge = items[i].getBoundingClientRect();
            if (edge.left < view.left - 2) {
              scroller.scrollTo({ left: sl - (view.right - edge.right), behavior: 'smooth' });
              return;
            }
          }
        }
      }

      scroller.addEventListener('click', function (event) {
        var item = event.target.closest('button');
        if (item && scroller.contains(item)) reveal(item);
      });
      scroller.addEventListener('scroll', updateArrows, { passive: true });
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      window.addEventListener('resize', updateArrows);
      if (window.ResizeObserver) new ResizeObserver(updateArrows).observe(scroller);
      updateArrows();
      requestAnimationFrame(updateArrows);
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.oaReady === 'true') return;
    root.dataset.oaReady = 'true';

    relocateAnchorNav(root);
    initPills(root);
    if (root.querySelector('[data-oa-scene-stage]')) {
      initScenes(root);
    } else {
      initTabs(root, '[data-oa-scene-tab]', '[data-oa-scene-card]', 'data-oa-scene');
    }
    initTabs(root, '[data-oa-acc-tab]', '[data-oa-acc-card]', 'data-oa-acc');
    initAccessories(root);
    initVsMore(root);

    root.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-oa-add]');
      if (!btn || !root.contains(btn)) return;
      event.preventDefault();
      var ids = (btn.getAttribute('data-ids') || '').split(',');
      addItems(ids, btn).catch(function () {});
    });
  }

  ready(function () {
    document.querySelectorAll('[data-oa-channel]').forEach(initRoot);
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    event.target.querySelectorAll('[data-oa-channel]').forEach(function (root) {
      root.dataset.oaReady = '';
      initRoot(root);
    });
  });
})();
